const state = {
  // 进度条控制
  publicProgressNum: 0,
  showPublicProgress: false,
}
const getters = {
  getPublicProgress: (state) => state.publicProgressNum,
  getShowProgress: (state) => state.showPublicProgress,
}
const mutations = {
  setShowPublicProgress: (state, flag) => {
    state.showPublicProgress = flag === true
  },
  setPublicProgress: (state, num) => state.publicProgressNum = num <= 100? parseInt(num): 100
}
const actions = {}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
